import { observer } from "mobx-react-lite"
import InsideUsersStyled from "./inside-users.page.styled"
import { useStore } from "../../../../hooks/store.hook";
import { useCallback, useEffect, useMemo, useState } from "react";
import PageTemplateComponent from "../../../../components/page-template/page-template.component";
import { PanelType } from "../../../../enums/panel-type.enum";
import InsideUserPanel from "../../../../components/inside-user-panel/inside-user-panel.component";
import { getAllAdminUsers } from "../../../../utils/requests";
import { displayCustomToast } from "../../../../utils/display-custom-toast";
import TableComponent, { ActionItemPropsType, CustomRendererPropsType, TableDataPropsType } from "../../../../components/table/table.component";
import { HeaderTypeEnum } from "../../../../enums/header-type.enum";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { EditOutlined } from "@mui/icons-material";
import LockResetIcon from '@mui/icons-material/LockReset';
import { TableTypeEnum } from "../../../../enums/table-type.enum";
import ResetPasswordPartnerUsersPanel from "../../../../components/partner-users-panel/components/reset-password-partner-user-panel/reset-password-partner-user-panel.component";

const InsideUsersPage = observer(() => {

    const uiStore = useStore('uiStore');
    const [refreshData, setRefreshData] = useState<boolean>(true);
    const [data, setData] = useState<any>();
    const [dataLoading, setDataLoading] = useState<boolean>(true);
    const [filtersTable, setFilters] = useState<any>({
        pageIndex: 0,
        pageSize: 5,
      //   selectFilterValue: null,
      //   secondSelectFilterValue: null,
      //   tabFilterValue: undefined,
        searchText: null
    });
    const [actionItemsClick, setActionItemsClick] = useState<any>();

    const createData = useCallback(
        () => {
            uiStore.openPanel({
                key: PanelType.CreateInsiderUser,
                component: <InsideUserPanel />,
                panelWidth: '700px',
                title: `Creare utilizator intern`,
                onDismiss: (data: any) => {
                    if(!data) return;
                    
                    if(data?.refreshData)
                        setRefreshData(() => true);
                }
            });
        },
        []
    )

    useEffect(
        () => {
            async function getData() {
                try {
                    setDataLoading(() => true)
                    let fetchData = await getAllAdminUsers({
                        pageIndex:filtersTable.pageIndex + 1,
                        pageSize:filtersTable.pageSize,
                        searchText:filtersTable.searchText
                    });
                    setData(() => fetchData)
                    setDataLoading(() => false)
                } catch (error: any) {
                    displayCustomToast(error.content, true);
                    setDataLoading(() => false)
                }
            }
            
            if(!refreshData) return;

            getData();
            setRefreshData(() => false);
            
        },
        [filtersTable, refreshData]
    )

    const tableData = useMemo(
        (): TableDataPropsType => {
            if(!data) return {
                data: [],
                headers: []
            }

            return {
                data: data.data,
                headers: [
                   {
                        id: 'firstName',
                        label: 'Nume',
                        headerType: HeaderTypeEnum.String,
                        alignment: 'left',
                        sortable: false
                    },
                   {
                        id: 'lastName',
                        label: 'Prenume',
                        headerType: HeaderTypeEnum.String,
                        alignment: 'center',
                        sortable: false
                    },
                    {
                        id: 'email',
                        label: 'Email',
                        headerType: HeaderTypeEnum.String,
                        alignment: 'center',
                        sortable: false
                    },
                   {
                        id: 'phoneNumber',
                        label: 'Numar de telefon',
                        headerType: HeaderTypeEnum.String,
                        alignment: 'center',
                        sortable: false
                    },
                    {
                         id: 'isActive',
                         label: 'Activ',
                         headerType: HeaderTypeEnum.Boolean,
                         alignment: 'center',
                         sortable: false
                     }
                ],
                totalElements: data.totalNumber
            }
        },
        [data]
    )

    const actionItems: ActionItemPropsType[] = useMemo(
        () => {
            return [
                {
                    text: "Resetare parola",
                    icon: <LockResetIcon />,
                    color: "black",
                    fOnClick: (row: any) => {
                        uiStore.openPanel({
                            key: PanelType.ResetPasswordAdminUsers,
                            component: <ResetPasswordPartnerUsersPanel
                                userId={row.id}
                                isAdminUser
                            />,
                            panelWidth: '700px',
                            title: `Resetare parola utilizator: ${row.firstName} ${row.lastName}`,
                            onDismiss: (data: any) => {
                                if (!data) return;

                                if (data?.refreshData)
                                    setRefreshData(() => true);
                            }
                        });
                    }
                },
                {
                    text: "Editeaza utilizator",
                    icon: <EditOutlined />,
                    color: "black",
                    fOnClick: (row: any) => {
                        uiStore.openPanel({
                            key: PanelType.EditPartnerUser,
                            component: <InsideUserPanel
                                insideUserId={row.id}
                            />,
                            panelWidth: '700px',
                            title: `Editeaza utilizatorul: ${row.firstName} ${row.lastName}`,
                            onDismiss: (data: any) => {
                                if (!data) return;

                                if (data?.refreshData)
                                    setRefreshData(() => true);
                            }
                        });
                    }
                },
            ];
        },
        [actionItemsClick]
    )

    const customRenderer: CustomRendererPropsType = useMemo(
        () => {
            return {
                isActive: (row: any) => {
                    return (
                        <>
                            {
                                row.isActive ?
                                    <CheckIcon color="success"  />
                                    :
                                    <CloseIcon color="error"  />
                            }
                        </>
                    )
                }
            }
        },
        []
    )

    return (
        <InsideUsersStyled>
            <PageTemplateComponent 
                title="Utilizatori interni"
                buttons={[
                    {
                        fOnClick: () => {
                            createData()
                        },
                        text: "Creeaza"
                    }
                ]}
            >

                <TableComponent
                    tableKey={TableTypeEnum.AllInsideUsers} 
                    viewType="normal"
                    tableData={tableData}
                    searchBarPlaceholder="Cauta dupa nume"
                    withoutSelect
                    isLoading={dataLoading}
                    tableState={filtersTable}
                    setTableState={setFilters}
                    actionItems={actionItems}
                    actionItemsClick={setActionItemsClick}
                    setRefreshData={setRefreshData}
                    customRenderer={customRenderer}
                />  
            </PageTemplateComponent>
        </InsideUsersStyled>
    )
})

export default InsideUsersPage